import React, { useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Scale, FileText, Users, Home as HomeIcon, Landmark, Receipt } from 'lucide-react';
import PracticeAreaModal from './PracticeAreaModal';
import { practiceAreaDetails } from '../practiceAreaData';

const PracticeAreas = ({ t, language = 'en' }) => {
  const [selectedArea, setSelectedArea] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const areas = practiceAreaDetails[language];

  const handleCardClick = (areaKey) => {
    setSelectedArea(areas[areaKey]);
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedArea(null), 200);
  };

  return (
    <>
      <section id="practice" className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-gray-900" style={{ fontFamily: 'Crimson Text, serif' }}>{t.practice_title}</h2>
          <p className="text-center text-gray-600 mb-12">{t.practice_subtitle}</p>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <Card 
              className="hover:shadow-lg transition-all cursor-pointer hover:scale-105"
              onClick={() => handleCardClick('criminal')}
            >
              <CardContent className="pt-6">
                <Scale className="h-10 w-10 text-amber-600 mb-4" />
                <h3 className="text-lg font-bold mb-2 text-gray-900">Criminal Law</h3>
                <p className="text-gray-600 text-sm">FIRs, Bail, Trials</p>
                <p className="text-amber-600 text-xs mt-2 font-semibold">Click for details →</p>
              </CardContent>
            </Card>
            
            <Card 
              className="hover:shadow-lg transition-all cursor-pointer hover:scale-105"
              onClick={() => handleCardClick('civil')}
            >
              <CardContent className="pt-6">
                <FileText className="h-10 w-10 text-amber-600 mb-4" />
                <h3 className="text-lg font-bold mb-2 text-gray-900">Civil Litigation</h3>
                <p className="text-gray-600 text-sm">Disputes, Recovery</p>
                <p className="text-amber-600 text-xs mt-2 font-semibold">Click for details →</p>
              </CardContent>
            </Card>
            
            <Card 
              className="hover:shadow-lg transition-all cursor-pointer hover:scale-105"
              onClick={() => handleCardClick('family')}
            >
              <CardContent className="pt-6">
                <Users className="h-10 w-10 text-amber-600 mb-4" />
                <h3 className="text-lg font-bold mb-2 text-gray-900">Family Law</h3>
                <p className="text-gray-600 text-sm">Divorce, Custody</p>
                <p className="text-amber-600 text-xs mt-2 font-semibold">Click for details →</p>
              </CardContent>
            </Card>
            
            <Card 
              className="hover:shadow-lg transition-all cursor-pointer hover:scale-105"
              onClick={() => handleCardClick('property')}
            >
              <CardContent className="pt-6">
                <HomeIcon className="h-10 w-10 text-amber-600 mb-4" />
                <h3 className="text-lg font-bold mb-2 text-gray-900">Property Disputes</h3>
                <p className="text-gray-600 text-sm">Land, Possession</p>
                <p className="text-amber-600 text-xs mt-2 font-semibold">Click for details →</p>
              </CardContent>
            </Card>
            
            <Card 
              className="hover:shadow-lg transition-all cursor-pointer hover:scale-105"
              onClick={() => handleCardClick('banking')}
            >
              <CardContent className="pt-6">
                <Landmark className="h-10 w-10 text-amber-600 mb-4" />
                <h3 className="text-lg font-bold mb-2 text-gray-900">Banking & Finance</h3>
                <p className="text-gray-600 text-sm">Loan Recovery</p>
                <p className="text-amber-600 text-xs mt-2 font-semibold">Click for details →</p>
              </CardContent>
            </Card>
            
            <Card 
              className="hover:shadow-lg transition-all cursor-pointer hover:scale-105"
              onClick={() => handleCardClick('cheque')}
            >
              <CardContent className="pt-6">
                <Receipt className="h-10 w-10 text-amber-600 mb-4" />
                <h3 className="text-lg font-bold mb-2 text-gray-900">Cheque Bounce</h3>
                <p className="text-gray-600 text-sm">NI Act Section 138</p>
                <p className="text-amber-600 text-xs mt-2 font-semibold">Click for details →</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      <PracticeAreaModal 
        isOpen={isModalOpen}
        onClose={handleClose}
        areaData={selectedArea}
      />
    </>
  );
};

export default PracticeAreas;
